import React, { Component, PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import ModalDialog from 'common/components/modal/modal_dialog';
import { TextAreaField, DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';
import { createSolicitationRequest } from 'project/ducks/wrapup';

let Form = ({ error, handleSubmit, submitting, submitFailed, onClose }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field name="message" component={TextAreaField} rows={5} />

      <div className="modal-actions">
        <AnimatedButton processing={submitting} type="submit" label="Send"
          processingLabel="Sending..." errorMsg={error || submitFailed}
          successMsg="Done!" baseBtnClass="btn btn-tertiary btn-block" />

        <button className="btn btn-text btn-block" onClick={onClose}>
          Cancel
        </button>
      </div>
    </form>
  );
}

const validate = (values) => {
  if (!values.message) {
    return { message: DEFAULT_REQUIRED_MESSAGE };
  }
}

Form = reduxForm({
  form: "solicitation_modal",
  validate,
})(Form);

export default class SoliciationModal extends Component {
  constructor(props) {
    super(props);

    this.state = { done: false };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleSubmit(formData) {
    const { wrapup } = this.props;

    return createSolicitationRequest(wrapup.award.id, formData).then((res) => {
      this.setState({ done: true })
    }).catch((res) => {
      throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
    });
  }

  handleClose() {
    this.setState({ done: false });
    this.props.onClose();
  }

  render() {
    const { wrapup, showing } = this.props;

    return (
      <ModalDialog
        modalOpen={showing}
        dialogClasses="solication-modal"
        closeAction={this.handleClose}
        modalHeader={`Ask ${wrapup.client.username} about more work`}
      >
        { this.state.done?
        <div className="row columns text-center">
          <h3 className="text-success">
            <i className="fa fa-check-circle fa-2x" /><br/>
            Note sent!
          </h3>

          <div className="modal-actions">
            <button className="btn btn-tertiary btn-block" onClick={this.handleClose}>Done</button>
          </div>
        </div>:
        <div className="row columns small-16">
          <p>
            Add a personal note and suggest ways you and the client can continue working together
            in a 1-to-1 project, or ask if they have additional work for you.
          </p>
          <Form {...this.props} onSubmit={this.handleSubmit} onClose={this.handleClose} />
        </div>}
      </ModalDialog>
    );
  }
}

SoliciationModal.propTypes = {
  wrapup: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/solicitation_modal.jsx